import React, {useCallback, useContext} from 'react';
import InteractionsList from "./InteractionsList";
import Portal from "../../containers/Portal";
import {CSSTransition} from 'react-transition-group';
import './styles/InteractionsPopup.scss';
import AppContext from "../../store";

const TEXT_TITLE = 'STEUERUNG';
const TEXT_BUTTON = 'OKAY';

export default function InteractionsPopup() {
  const {
    isInteractionsPortalOpen,
    toggleInteractionsPortal,
  } = useContext(AppContext);
  
  const handleOnClick = useCallback(
    () => toggleInteractionsPortal(false),
    [toggleInteractionsPortal]
  );

  return (
    <Portal id={"InteractionsPortal"}>
      <CSSTransition
        in={isInteractionsPortalOpen}
        appear={true}
        classNames="fade"
        timeout={700}
        mountOnEnter
        unmountOnExit
      >
        <div className="interactions-popup">
          <div className="interactions-popup-container">
            <span className="interactions-popup-text">{TEXT_TITLE}</span>
            <InteractionsList className={'interactions-list-inside-popup'} />
            <span
              onClick={handleOnClick}
              className="interactions-popup-button">{TEXT_BUTTON}
            </span>
          </div>
        </div>
      </CSSTransition>
    </Portal>
  )
}